/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector } from 'react-redux';
// material
import AsideToggle from '../sidebar/controls/asidetoggle/asidetoggle';
// styles
import injectSheet from 'react-jss';
import styles from './header_styles';



/* ========== ~~~~~~~~~~ HEADER ~~~~~~~~~~ ========== */
const Header = injectSheet(styles)((props) => {
	const sidebarOpen = useSelector(state => state.app.sidebarOpen)
	return (
		<header className={`${props.classes.header} sidebarOpen-${sidebarOpen}`}>
			<AsideToggle />
			<div className={'headercontent'}>
				{props.children}
			</div>
		</header>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Header;
